const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const SubscriptionItemAdd = () => import(/* webpackChunkName: "subscription" */ './item/view/add.vue');
const SubscriptionItemDetail = () => import(/* webpackChunkName: "subscription" */ './item/view/detail.vue');
const SubscriptionItemEdit = () => import(/* webpackChunkName: "subscription" */ './item/view/edit.vue');
const SubscriptionItemList = () => import(/* webpackChunkName: "subscription" */ './item/view/index.vue');
const SubscriptionItemTranslate = () => import(/* webpackChunkName: "subscription" */ './item/view/translate.vue');

export const ROUTE_NAME_SUBSCRIPTION = {
    INDEX: 'SubscriptionItemList',
    ADD: 'SubscriptionItemAdd',
    EDIT: 'SubscriptionItemEdit',
    CLONE: 'SubscriptionItemClone',
    DETAIL: 'SubscriptionItemDetail',
    TRANSLATE: 'SubscriptionItemTranslate'
} as const;

export default [
    {
        path: '/app/:appId/subscription/item',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_SUBSCRIPTION.INDEX,
                component: SubscriptionItemList,
                meta: { requiresAuth: true }
            },
            {
                path: 'add',
                name: ROUTE_NAME_SUBSCRIPTION.ADD,
                component: SubscriptionItemAdd,
                meta: { requiresAuth: true }
            },
            {
                path: ':id',
                name: ROUTE_NAME_SUBSCRIPTION.EDIT,
                component: SubscriptionItemEdit,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/clone',
                name: ROUTE_NAME_SUBSCRIPTION.CLONE,
                component: SubscriptionItemAdd,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/detail',
                name: 'SubscriptionItemDetail',
                component: SubscriptionItemDetail,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/translate',
                name: 'SubscriptionItemTranslate',
                component: SubscriptionItemTranslate,
                meta: { requiresAuth: true }
            }
        ]
    }
];
